import PropTypes from "prop-types";
import { ModalConfirm } from "@evertrue/et-components";

const InterestEnrichmentModal = ({ close, children }) => {
  return (
    <ModalConfirm header="Interests" onCancel={close} style={{ width: 500 }}>
      <div className="profile-enrichment--more-modal">{typeof children === "function" ? children() : children}</div>
    </ModalConfirm>
  );
};

InterestEnrichmentModal.propTypes = {
  close: PropTypes.func,
  children: PropTypes.any,
};

InterestEnrichmentModal.defaultProps = {
  close: () => null,
  children: null,
};

export default InterestEnrichmentModal;
